module.exports = __webpack_public_path__ + "static/media/emoji6.e2cad3fa.png";